/**
 * Enum for brands.
 */

export const INSTABOX = 'INSTABOX'
export const BUDBEE = 'BUDBEE'
export const PORTERBUDDY = 'PORTERBUDDY'
